/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://dev.portal.rapidxs.nl/api';
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
